import { ShelterSiteModel } from "../../../../../../petszel-shared/src/lib/shared-models/shelter-site.model";

export interface ShelterSitesState {
  initialState: boolean;
  sites: ShelterSiteModel[];
}

export const initialShelterSitesState: ShelterSitesState = {
  initialState: true,
  sites: [],
};
